import createReducer from 'utils/createReducer';

export const COMMON_FILTERS_STORAGE = 'common/filters';

const filtersByDefault = {
  routes: [{ label: 'All', value: 'all' }],
};

const filters = localStorage.getItem(COMMON_FILTERS_STORAGE);
const defaultFilters =
  (filters && {
    ...filtersByDefault,
    ...JSON.parse(filters),
  }) ||
  filtersByDefault;

const SET_COMMON_FILTER = 'common/SET_COMMON_FILTER';

// Initial State
const INIT_STATE = {
  filters: defaultFilters,
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_COMMON_FILTER](state, payload) {
    return {
      ...state,
      filters: payload,
    };
  },
});

export const setFilter = (filters) => ({
  type: SET_COMMON_FILTER,
  payload: filters,
});
